export const FETCH_ZONES = "FETCH_ZONES";
export const FETCH_ZONE = "FETCH_ZONE";
export const UPDATE_DURATION = "UPDATE_DURATION"
export const UPDATE_ZONE_FILTERS = "UPDATE_ZONE_FILTERS"
export const FETCH_BLACKLISTED_CANDIDATES = "FETCH_BLACKLISTED_CANDIDATES"
